import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GRAPH_BASE } from "../const/app.consts";
export var msGraphApi = createApi({
    reducerPath: 'msGraphApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GRAPH_BASE,
    }),
    tagTypes: ['messages'],
    endpoints: function (builder) { return ({
        messages: builder.query({
            query: function () { return ({
                url: 'v1.0/me/messages',
                method: "GET",
            }); },
            providesTags: ['messages']
        }),
        createEmail: builder.mutation({
            query: function (_a) {
                var message = _a.message, accessToken = _a.accessToken;
                return ({
                    url: '/v1.0/me/messages',
                    method: 'POST',
                    body: message,
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken)
                    }
                });
            },
        }),
        updateEmail: builder.mutation({
            query: function (_a) {
                var id = _a.id, message = _a.message, accessToken = _a.accessToken;
                return ({
                    url: "/v1.0/me/messages/".concat(id),
                    method: 'PATCH',
                    body: message,
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken)
                    }
                });
            },
        }),
        sendEmail: builder.mutation({
            query: function (_a) {
                var message = _a.message, accessToken = _a.accessToken;
                return ({
                    url: "/v1.0/me/messages/".concat(message.id, "/send"),
                    method: 'POST',
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken)
                    }
                });
            },
        }),
        addAttachment: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = _a.body, accessToken = _a.accessToken;
                return ({
                    url: "/v1.0/me/messages/".concat(id, "/attachments"),
                    method: 'POST',
                    body: body,
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken),
                        "Content-Type": 'application/json'
                    }
                });
            },
        }),
        execPut: builder.mutation({
            query: function (_a) {
                var url = _a.url, body = _a.body, accessToken = _a.accessToken;
                return ({
                    url: "/v1.0/me/".concat(url),
                    method: 'PUT',
                    body: body,
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken)
                    }
                });
            },
        }),
        execGet: builder.query({
            query: function (_a) {
                var url = _a.url, accessToken = _a.accessToken;
                return ({
                    url: "v1.0/me/".concat(url),
                    method: "GET",
                    headers: {
                        "Authorization": "Bearer ".concat(accessToken)
                    },
                });
            }
        }),
    }); }
});
// export const {useMessagesQuery} = msGraphApi
export default msGraphApi;
